import React, {PureComponent} from "react";

import Date from "../Moment/Date.jsx";

import IcnLost from './assets/images/icn-lost.svg'
import IcnWin from './assets/images/icn-valid.svg'
import IcnOnGoing from './assets/images/icn-ongoing.svg'

import Card from "../Styled/Dasboard/Card.jsx";
import CardCol from "../Styled/Dasboard/CardCol.jsx";
import CardRow from "../Styled/Dasboard/CardRow.jsx";

import Link from "../Link/Link.jsx";

import {POSITIONING_STATUS} from "../../constants.js";

import './Positioning.scss'

export default class Positioning extends PureComponent {

  getStatusIcon = (status) => {
    switch (status) {
    case POSITIONING_STATUS.WON:
      return IcnWin;
    case POSITIONING_STATUS.LOST:
      return IcnLost;
    default:
      return IcnOnGoing;
    }
  };

  render() {
    const {positionings, generate} = this.props

    return (
      <Card  className="dashboard-card-positionings" title={'Mes derniers positionnements '}>
        {(positionings.length >= 1)
          ? <div>
            {positionings.map((positioning, index) => {
              const statusIcon = this.getStatusIcon(positioning.status)
              return <div className="positioning-row" style={{display: 'flex'}} key={`positioning-row-${index}`}>
                <div className="positioning-row-col positioning-title" >{positioning.title}</div>
                <div className="positioning-row-col positioning-positioned-at">
                  {<Date format="dd/MM/yyyy" date={positioning.positioned_at}/>}
                </div>
                <div className="positioning-row-col positioning-status">
                  {statusIcon ? <img src={statusIcon} alt="positionning status" width='18px'/>: null}
                </div>
              </div>
            })}
          </div>
          : <CardRow className="positioning-card-row-cta-container">
            <CardCol flex="unset">Aucun positionnement sur une mission pour le moment</CardCol>
          </CardRow>
        }

        <CardRow className="positioning-card-row-cta-container">
          <CardCol flex="unset">
            <Link
              className="btn btn-primary"
              to={generate({
                name: `my-positions-and-missions`,
              })} >
              Voir plus
            </Link>
          </CardCol>
        </CardRow>
      </Card>
    )
  }
}